
import Group from 'vux/src/components/group/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import pkHeader from  '../common/header/header.vue';
const list = () => ['航班号','起降城市']
export default {
components:{
Box,
Group,
pkHeader,
Cell,
Icon,
XInput,
Tab,
Flexbox,
TabItem,
FlexboxItem,
XButton
},
data() {
return {
title:"查询航班",
value:'',
start:"",
end:"",
tabIndex:0,
showBack:false,
list:list(),
airNo:"",
defaultIndex:this.$until.getUrlParam('tabIndex') == 1 ? '起降城市' : '航班号',

jbStorage:JSON.parse(localStorage.getItem("jbStorage")) || {},
quirydate:localStorage.getItem("quirydate") || new Date().format('yyyy-MM-dd')
}
},
methods:{
selectTab(item){
this.defaultIndex = item;
if(this.tabIndex == 1){
this.start = "";
this.end = "";
}
},
goback(){
setTimeout(()=>{
this.$router.push("/pickupAircraft");
},500)
localStorage.setItem("quirydate",new Date().format('yyyy-MM-dd'));
},
chooseDate(){
var preDate =  localStorage.getItem("$PreDate");

if(!preDate){


this.$http.post(window.innerAPI + "?server=queryPreDay", {}).then(res => {
if(res.data.data.code){return;}
preDate =  res.data.data.data;
var index =  location.href.indexOf("?") != -1 ? location.href.substr(0,location.href.indexOf("?")) : location.href.substr(0,location.href.length);
location.href = '/station/choosedate?backUrl=' + encodeURIComponent(index+"?tabIndex="+this.tabIndex+"&airNo="+this.airNo+"&start="+this.start+"&end="+this.end)+"&preDate="+preDate;

localStorage.setItem("$PreDate", res.data.data.data)
})
return;
}

var index =  location.href.indexOf("?") != -1 ? location.href.substr(0,location.href.indexOf("?")) : location.href.substr(0,location.href.length);
location.href = '/station/choosedate?backUrl=' + encodeURIComponent(index+"?tabIndex="+this.tabIndex+"&airNo="+this.airNo+"&start="+this.start+"&end="+this.end)+"&preDate="+preDate;
},

changeCity(){
this.imgUrl = this.imgUrl.indexOf('singers') == -1 ? '../static/img/singers.png' : '../static/img/singer.png'
let cc = this.start
this.start = this.end
this.end = cc
},
formateDate(v){
if(new Date(v)<new Date()){
return new Date().format('MM月dd日 周W 起飞')
}else{
return new Date(v).format('MM月dd日 周W 起飞')
}
},
linkto(v){
this.$router.push("/posi?back=serachAircraft&from=1&stag=" + v)
},

serach(){
if (this.defaultIndex == '航班号'){
if (this.airNo == ''){
this.$vux.toast.show({
text:"请输入航班号",
type:"text"
})
return false
}
else {
if(!/^[0-9a-zA-Z]*$/.test(this.airNo)||this.airNo.length>10){
this.$vux.toast.show({
text:"只支持输入10位以内的拼音和数字",
type:"text"
})
return false
}
}
this.$router.push("/serachAircraftList?date=" + this.quirydate + "&airNo=" + this.airNo)
} else {
if (!this.start || !this.end){
this.$vux.toast.show({
text:!this.start ? "请设置起飞和到达城市" : "请输入到达城市",
type:"text"
})
return false
}
this.$router.push("/serachAircraftList?date=" + this.quirydate + "&start=" + this.start + "&end=" + this.end.split('市')[0])
}
}
},
mounted(){
this.start = this.jbStorage.start||this.$until.getUrlParam("start")
this.end = this.jbStorage.end ||this.$until.getUrlParam("end")
this.airNo =  this.$until.getUrlParam("airNo")?this.$until.getUrlParam("airNo"):"";

},
activated(){
}
};



// WEBPACK FOOTER //
// ./src/components/pickGiveAircraft/serachAircraft.vue